import { Parameters } from 'constants/queryParameters';
import { useQuerySearchParams } from './useQuerySearchParams';

export const useQueryFilters = () => {
  const [status, setStatus] = useQuerySearchParams<string>(Parameters.status);
  const [userProfileType, setUserProfileType] = useQuerySearchParams<string>(
    Parameters.userProfileType,
  );
  const [custodianType, setCustodianType] = useQuerySearchParams<string>(
    Parameters.custodianType,
  );
  const [displaySepIra, setDisplaySepIra] = useQuerySearchParams<boolean>(
    Parameters.displaySepIra,
  );
  const [onlyFunded, setOnlyFunded] = useQuerySearchParams<boolean>(
    Parameters.onlyFunded,
  );
  const [accountClosed, setAccountClosed] = useQuerySearchParams<boolean>(
    Parameters.accountClosed,
  );
  const [search, setSearch] = useQuerySearchParams<string>(Parameters.search);

  return {
    status,
    setStatus,
    userProfileType,
    setUserProfileType,
    custodianType,
    setCustodianType,
    displaySepIra,
    setDisplaySepIra,
    onlyFunded,
    setOnlyFunded,
    accountClosed,
    setAccountClosed,
    search,
    setSearch,
  };
};
